export default __webpack_public_path__ + "static/media/goi-and.6c084754.svg";